import React from 'react';

function PropertyDropDown(props) {
  
    return(
        <div>
            {
                props.properties.map(property => {
                return property.hasOwnProperty('suggestion') && (
                    <li key={property['businessId']} onClick={e => props.onSelectProperty(e, property)}>{property['suggestion']}</li>
                )
                })
            }
        </div>
    )
}

export default PropertyDropDown;